export { default as ProductsElasticSearchAppliedFilters } from './ProductsElasticSearchAppliedFilters';
